import React, { useState,useEffect }  from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';

import { BASE_URL } from '../Config/Base';
//import { ToastContainer, toast } from 'react-toastify';
import { Oval } from  'react-loader-spinner'
import _ from 'lodash'


const pageSize =5;
const pageSizeB =5;
const TecLifeMain = () => {

  useEffect(()=>{  
    
   

    setTimeout(() => {
            
  
      getroleAction() 
    
        
       }, 2000);
   
  }, [])
  const[pop,setpop] = useState(false);
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

  const [sectionLife, setSectionLife] = useState([])
  const [EditSectionLife, setEditSectionLife] =useState([])
    const [paginatedPosts, setpaginatedPosts] = useState();
     const [currentPage, setcurrentPage] = useState(1);
     const [paginatedPostsB, setpaginatedPostsB] = useState();
     const [currentPageB, setcurrentPageB] = useState(1);

  ///getTecLife


  function getTecLife()
  {



  fetch(`${BASE_URL}/Tec/GettecLife`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("DatasectionA", data);
      setSectionLife(data)
      setpaginatedPostsB(_(data).slice(0).take(pageSizeB).value());
        }
    );



      }
      const pageCountB = sectionLife? Math.ceil(sectionLife.length/pageSizeB) :0;
      // if (pageCountB === 1)
      // return null;
      
      const pagesB = _.range(1, pageCountB+1)
      
      const paginationB =(pageNoB)=>{
      setcurrentPageB(pageNoB);
      const startIndex = (pageNoB - 1) * pageSizeB;
      const paginatedPostB = _(sectionLife).slice(startIndex).take(pageSizeB).value();
      setpaginatedPostsB(paginatedPostB)
      }
      const onNextB = () => {


        paginationB(currentPageB + 1);
      };
      
      const onPreviousB = () => {
        paginationB(currentPageB - 1);
      };
      ///submitsection

   const [fileLife, setFileLife] = useState();
   const [fileLifeImg, setFileLifeImg] = useState();
   // console.log(file)
   
   const handleFileChangeLife = (e) => {
    
       setFileLife(e.target.files[0]);
       setFileLifeImg(URL.createObjectURL(e.target.files[0]));
      
   };
 
   function submitsectionLife(){

    var UserId= localStorage.getItem('UserId')

     var textLife = document.getElementById("text").value;


     if(!textLife){

       document.getElementById("AddErrA").innerHTML="Description Required"

     }
     else if(textLife){

       document.getElementById("AddErrA").innerHTML=" "

     }
     
     if(!fileLife){

       document.getElementById("AddErrB").innerHTML="image Required"

     }
     else if(fileLife){

       document.getElementById("AddErrB").innerHTML=" "

     }

     if(textLife &&fileLife){



    const body =
     {
       
       Text:textLife, 
       Image:fileLife,
       ActiveStatus:0,
       DeleteStatus:0,
       CreatedBy:UserId
       

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/AddtecLife`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
          setSuccessToast(true)
           
          
             setTimeout(() => {
              setSuccessToast(false)
              getTecLife()

              closeLifeAddForm()
             }, 2000);
           }

   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed !")

     })
       
   }

   }


   
     ////Get Particular Data PostMethod

     function editSectionLife(Id){

      SelectParticular(Id)

      document.getElementById("LifeEditPop").style.display = "block";
     }
      function SelectParticular(Id){
    const body =
     {
       
      id:Id
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/EdittecLife`,
            data:body, 
            headers: {
                 "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
         
    
         .then((response) =>{
           console.log(JSON.stringify(response.data));
      
       
           setEditSectionLife(response.data)

          
      
        })
        .catch(error => {
          console.log(error);
          
        })

     }



     function updateSectionLife(Id){


      var UserId= localStorage.getItem('UserId')
       var TextLife = document.getElementById("textA").value;
       var ImagefileLife = document.getElementById("tecimage").src;

       if(!TextLife){

         document.getElementById("ErrA").innerHTML="Description Required"

       }
       else if(TextLife){

         document.getElementById("ErrA").innerHTML=" "

       }
       
      
      
      
       if(TextLife){


       



    const body =
     {
       Id:Id,
       Text:TextLife, 
       Image:fileLife,
       OldImage:ImagefileLife,
       EditedBy:UserId

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/UpdatetecLife`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){


          closeLifeEditForm()
          setUpdateToast(true)
           
             setTimeout(() => {
             
              getTecLife()
              setUpdateToast(false)
             
             }, 2000);
           }
   
     })
     .catch(error => {
       console.log(error);
       alert("failed !")
     
     })
       
    
   }

     }
   

   ///DeleteSectionA

   function DeleteSectionLife(Id){

 
   

    const body =
     {
       Id:Id,
    
      

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/DeletetecLife`,
            data:body, 
            headers: {
               "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        closeForm()
        setDeleteErrToast(true)
             
           
             setTimeout(() => {
             
              getTecLife()

              
              setDeleteErrToast(false)
              
             }, 2000);
            
             
           
   
     })
     .catch(error => {
       console.log(error);
       alert("failed !")
      
     })
       
    

   

   }





   //closeAddForm

   function closeLifeAddForm(){


    setFileLife();
    setFileLifeImg()
   
 
    document.getElementById("AddErrA").innerHTML=" "
    document.getElementById("AddErrB").innerHTML=" "
   
    document.getElementById("tecform").reset();
           
    document.getElementById("LifeAddPop").style.display = "none";
   
   
  }

 
  
   //closeEditForm

  function closeLifeEditForm(){

   setFileLife();
   setFileLifeImg();
   document.getElementById("ErrA").innerHTML=" "
   document.getElementById("ErrB").innerHTML=" "
   document.getElementById("teceditform").reset();

   
   document.getElementById("LifeEditPop").style.display = "none";
  }



   //OpenAddForm

   function openLifeMainForm(){

    document.getElementById("LifeMainAddPop").style.display = "block";

  }

  const [sectionLifeMain, setSectionLifeMain] = useState([])
  const [EditSectionLifeMain, setEditSectionLifeMain] =useState([])


  ///getTecLife


  function getTecLifeMain()
  {


  fetch(`${BASE_URL}/Tec/GettecLifeMain`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",


      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("DatasectionA", data);
      setSectionLifeMain(data)
       setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        }
    );



      }

      const pageCount = sectionLifeMain? Math.ceil(sectionLifeMain.length/pageSize) :0;
      // if (pageCount === 1)
      // return null;
      
      const pages = _.range(1, pageCount+1)
      
      const pagination =(pageNo)=>{
      setcurrentPage(pageNo);
      const startIndex = (pageNo - 1) * pageSize;
      const paginatedPost = _(sectionLifeMain).slice(startIndex).take(pageSize).value();
      setpaginatedPosts(paginatedPost)
      }

      const onNext = () => {


        pagination(currentPage + 1);
      };
    
      const onPrevious = () => {
        pagination(currentPage - 1);
      };
      ///submitsection

   
 
   function submitsectionLifeMain(){

    var UserId= localStorage.getItem('UserId')

     var textLife = document.getElementById("Maintext").value;


     if(!textLife){

       document.getElementById("MainAddErrA").innerHTML="Description Required"

     }
     else if(textLife){

       document.getElementById("MainAddErrA").innerHTML=" "

     }
     
   

     if(textLife){



    const body =
     {
       
       Text:textLife, 
      
       ActiveStatus:0,
       DeleteStatus:0,
       CreatedBy:UserId
       

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/AddtecLifeMain`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
          setSuccessToast(true)
           
          
             setTimeout(() => {
             
              getTecLifeMain()
              setSuccessToast(false)
              closeLifeMainAddForm()
             }, 2000);
           }

   
     })
     .catch(error => {
       console.log(error);
       alert("failed !")
    

     })
       
   }

   }


   
     ////Get Particular Data PostMethod

     function editSectionLifeMain(Id){

      SelectParticularMain(Id)
      document.getElementById("LifeMainEditPop").style.display = "block";
     }
      function SelectParticularMain(Id){
    const body =
     {
       
      id:Id
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/EdittecLifeMain`,
            data:body, 
            headers: {
                 "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
         
    
         .then((response) =>{
           console.log(JSON.stringify(response.data));
      
       
           setEditSectionLifeMain(response.data)

          
      
        })
        .catch(error => {
          console.log(error);
          
        })

     }



     function updateSectionLifeMain(Id){

      var UserId= localStorage.getItem('UserId')
  
       var TextLife = document.getElementById("MaintextA").value;
       

       if(!TextLife){

         document.getElementById("MainErrA").innerHTML="Description Required"

       }
       else if(TextLife){

         document.getElementById("MainErrA").innerHTML=" "

       }
       
      
      
      
       if(TextLife){


       



    const body =
     {
       Id:Id,
       Text:TextLife, 
       EditedBy:UserId
       

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/UpdatetecLifeMain`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
        
          setUpdateToast(true)
          closeLifeMainEditForm()
             setTimeout(() => {
             
              getTecLifeMain()
              setUpdateToast(false)
              
             }, 2000);
           }
   
     })
     .catch(error => {
       console.log(error);
       alert("failed !")
        
     })
       
    
   }

     }
   

   ///DeleteSectionA

   function DeleteSectionLifeMain(Id){

 
 

    const body =
     {
       Id:Id,
    
      

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/DeletetecLifeMain`,
            data:body, 
            headers: {
               "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        MaincloseForm()
        
             setDeleteErrToast(true)
           
             setTimeout(() => {
             
              getTecLifeMain()
              setDeleteErrToast(false)
             
             }, 2000);
            
             
           
   
     })
     .catch(error => {
       console.log(error);
       alert("failed !")
        
     })
       
    

   

   }





   //closeAddFormMain

   function closeLifeMainAddForm(){


   
 
    document.getElementById("MainAddErrA").innerHTML=" "
    
   
    document.getElementById("Maintecform").reset();
           
    document.getElementById("LifeMainAddPop").style.display = "none";
   
   
  }

 
  
   //closeEditFormMain

  function closeLifeMainEditForm(){

   setFileLife();
   setFileLifeImg()
   document.getElementById("MainErrA").innerHTML=" "

   document.getElementById("Mainteceditform").reset();

   
   document.getElementById("LifeMainEditPop").style.display = "none";
  }

  //OpenAddFormMain

  function openLifeForm(){

    document.getElementById("LifeAddPop").style.display = "block";

  }


  function OpenTecGridMain(){
 
    getTecLifeMain()

    document.getElementById("TecGridMainA").style.display="block"
  
    document.getElementById("TecSelectMain").style.display="none"
    document.getElementById("PopAAdd").style.display="none"
    document.getElementById("PopATable").style.display="none"
    setpop(true);
  
    setTimeout(()=>{
    setpop(false);
    getAssignedActionMain()
  },1000)
    }
  
  
    function OpenAboutContent(){

      getTecLife()
      document.getElementById("TecSelectMain").style.display="none"
      document.getElementById("TecGridMainB").style.display="block"

      document.getElementById("PopBAdd").style.display="none"
      document.getElementById("PopBTable").style.display="none"
      setpop(true);
     
      setTimeout(()=>{
      setpop(false);
      getAssignedAction()
      
      
    },1000)
      
    }
  
  
    function BackMain(){
  
    document.getElementById("TecGridMainA").style.display="none"
    document.getElementById("TecGridMainB").style.display="none"
    document.getElementById("TecSelectMain").style.display="block"
  
    }
    

    function getroleAction(){

   

      let LoginRole =  localStorage.getItem("Role");
   
      console.log('checkrole',LoginRole);
      const body =
      {
        
       role:LoginRole
      }
      console.log('body',body);
  
    
      axios({
             method:"POST",
             url :`${BASE_URL}/Tec/GetTecRoleAction`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  "Authorization": bearer,
              }     
          }) 
          
     
          .then((response) =>{
            console.log(response.data);
       
         
         
                  
            localStorage.setItem("LoginAction",JSON.stringify(response.data))
            localStorage.getItem("LoginAction");
         })
         .catch(error => {
           console.log(error);
    })
  }
  
    const[editicon,setediticon] = useState(false);
    const[delicon,setdelicon] = useState(false);
    const[denied,setdenied] = useState(false);    
    function getAssignedActionMain(){
  
  
  
    ////Admin
      let LoginRole =  localStorage.getItem("RoleId");
    
  
      let CheckSAdmin = LoginRole.includes("00")
      let CheckAdmin =LoginRole.includes("01")
  
  
    /////////////Teammate
      let LoginAction =  localStorage.getItem("LoginAction");
      let TecRoleAction =  JSON.parse(LoginAction);
      let roleAction = TecRoleAction.map((e)=>e.roleAction);
      console.log(roleAction);
      
      let roles = roleAction.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      
      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
  
  
     
  
      if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopAAdd').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopAAdd').style.display ="block";
      }
      else{
        document.getElementById('PopAAdd').style.display ="none";
  
      }
      if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopATable').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopATable').style.display ="block";
      }
      else{
        document.getElementById('PopATable').style.display ="none";
  
      }
      if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
    
        setediticon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setediticon(true)
      }
      else{
        setediticon(false)
  
      }
      if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){
  
        setdelicon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setdelicon(true)
      }
      else{
        setdelicon(false)
  
      }
  
      if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){
  
        setdenied(true)
      }
      else{
  
        setdenied(false)
      }
      if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
        document.getElementById("TecActionDenied").innerHTML="View Table is not Assigned"
         }

    }
    function getAssignedAction(){
  
  
  
      ////Admin
        let LoginRole =  localStorage.getItem("RoleId");
      
    
        let CheckSAdmin = LoginRole.includes("00")
        let CheckAdmin =LoginRole.includes("01")
    
    
       /////////////Teammate
        let LoginAction =  localStorage.getItem("LoginAction");
        let TecRoleAction =  JSON.parse(LoginAction);
        let roleAction = TecRoleAction.map((e)=>e.roleAction);
        console.log(roleAction);
        
        let roles = roleAction.toString();
        let roleResult = roles.includes('Add')
        console.log(roleResult)
        
        let roleResultA = roles.includes('View')
        console.log(roleResultA)
        
        let roleResultB = roles.includes('Edit')
        console.log(roleResultB)
        
        let roleResultC = roles.includes('Delete')
        console.log(roleResultC)
    
    
       
    
        if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){
    
          document.getElementById('PopBAdd').style.display ="block";
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          document.getElementById('PopBAdd').style.display ="block";
        }
        else{
          document.getElementById('PopBAdd').style.display ="none";
    
        }
        if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
    
          document.getElementById('PopBTable').style.display ="block";
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          document.getElementById('PopBTable').style.display ="block";
        }
        else{
          document.getElementById('PopBTable').style.display ="none";
    
        }
        if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
    
          setediticon(true)
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          setediticon(true)
        }
        else{
          setediticon(false)
    
        }
        if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){
    
          setdelicon(true)
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          setdelicon(true)
        }
        else{
          setdelicon(false)
    
        }
  
        if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){
  
          setdenied(true)
        }
        else{
    
          setdenied(false)
        }

        if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
          document.getElementById("TecActionDeniedA").innerHTML="View Table is not Assigned"
           }
      }
      function MainConfirmDelete(Id){

        SelectParticularMain(Id)
        setTimeout(() => {
          document.getElementById("MainmodaldeleteForm").style.display = "block";
        },1000);
      
      }
      function ConfirmDelete(Id){
  
        SelectParticular(Id)
        setTimeout(() => {
          document.getElementById("modaldeleteForm").style.display = "block";
        },1000);
      
      }
  
      function MaincloseForm(){
  
        document.getElementById("MainmodaldeleteForm").style.display ="None"
      
      }
      function closeForm(){
  
        document.getElementById("modaldeleteForm").style.display ="None"
      
      }


      const[SuccessToast,setSuccessToast] = useState(false);  
      const[UpdateToast,setUpdateToast] = useState(false);  
      const[DeleteToast,setDeleteErrToast] = useState(false);
  return (

    <>

{/* Toast */}
{SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Added Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null} 


   {/* Toast */}
   {UpdateToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Updated Successfully!</p></div>
   
  </div></div></div></div>:null}
    <div className='tec-addmain' id="TecSelectMain" >
   
          
    {/* <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
        <div className='tec-addmain-back'>
           <Link to='/Tecsection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>Life Here</span>
 

     </div>
 </div> */}

<div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">LIFE HERE</span> </span>
 <div className='tec-addmain-back'>
  <Link to="/TecCompany"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div>
 </p> 

 {/* <hr></hr> */}
 </div> </div>  
 <div class="tec-hero"> 
  <div class="techero__title"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
</div>
 <div className='tecTwoList'>

  <div class="tecTwoList_responsive">
 <div id="TecSelectB" >

<div id="items-body-content" onClick={OpenTecGridMain}>
 <span>Add Main Content</span>
 <i class="fa fa-angle-right"></i>
</div>
<div id="items-body-content" onClick={OpenAboutContent}>
 <span>Add Content</span>
 <i class="fa fa-angle-right"></i>
</div>
</div>
    
</div> </div>  
 
    </div>
    <div id="TecGridMainA" className='tec-addmain'>


    <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">LIFE HERE MAIN</span></span>
 <div className='tec-addmain-back'>
  <Link onClick={BackMain}><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div>
 </p> 

 {/* <hr></hr> */}
 </div>

    </div>   

  <div className='tec-addmain-add' id="PopAAdd">
      <button className='add-user' onClick={openLifeMainForm}>  Add Main</button>
 </div>

  
    

 

 {/* EditLife */}
 <div className='tech-pop-fade' id="LifeMainEditPop">
{EditSectionLifeMain.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"220px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
        <button type="button" className="close" onClick={closeLifeMainEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="Mainteceditform" onSubmit={()=>updateSectionLifeMain(e.id)}>
      <div className="modal-body mx-3">
      
        
       
        <div className="md-form mb-5">
        <label id="sectionlable">Content</label> 
          <textarea type="text" id="MaintextA"  defaultValue={e.text}/>
          <span id="MainErrA" className='error'></span>
        </div> 
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddLife */}
<div className='tech-pop-fade' id="LifeMainAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"220px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD SECTION</h4>
        <button type="button" className="close" onClick={closeLifeMainAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="Maintecform" onSubmit={submitsectionLifeMain} >
      <div className="modal-body mx-3">
        
      
        <div className="md-form mb-5">
           
        <label id="sectionlable">Content</label> 
          <textarea type="text" id="Maintext"/>
          <span id="MainAddErrA" className='error'></span>
        </div> 
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 


{/* DeletePopup */}

{EditSectionLifeMain.map((e)=>{ 
   return<div className="tec-pop-fade" id="MainmodaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={MaincloseForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionLifeMain(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={MaincloseForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}




<div className='tec-sectionMain' id="PopATable" >
{
 sectionLifeMain.length==0  ? (<div id="TecApiFail">" No Data Found "</div>):(
<div>
<div className='tectable'>

  <div class="tec-table_responsive">

<table>
  <thead>
    <tr>
    
      <th>Content</th>
    
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {paginatedPosts.map((e)=>{
    
  
    return<tr>
   
  
    
    <td><div style={{inlineSize:"280px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.text}</div></td>
    <td style={{whiteSpace:"nowrap"}}>
    {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionLifeMain(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
    {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>MainConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}
      {denied?<span className='error'>Denied</span>:null}
    </td>
    </tr>
 } )}
  </tbody>
</table>

</div>
</div>

<br></br>
{pageCount==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
            
            {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
</div>
)}
 



   

    </div>

    
    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}
  id="Loader"
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}

<div id="TecDenied">
   <span id="TecActionDenied"></span>

   </div>
    </div>
    <div id="TecGridMainB" className='tec-addmain'>
    
     <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">LIFE HERE</span>  </span>
 <div className='tec-addmain-back'>
  <Link onClick={BackMain}><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div>
 </p> 

 {/* <hr></hr> */}
 </div>

    </div>   

  <div className='tec-addmain-add' id="PopBAdd">
      <button className='add-user' onClick={openLifeForm}>  Add Life here</button>
 </div>

  
    

 

 {/* EditLife */}
 <div className='tech-pop-fade' id="LifeEditPop">
{EditSectionLife.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"140px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
        <button type="button" className="close" onClick={closeLifeEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="teceditform" onSubmit={()=>updateSectionLife(e.id)}>
      <div className="modal-body mx-3">
      
        
        <div className="text-center md-form mb-5" style={{marginTop:"-25px"}}>
        {/* <label id="sectionlable">SlideImage</label> */}
       
         <input type="file" onChange={handleFileChangeLife} style={{opacity:"0",position:"relative",top:"50px",left:"200px",zIndex:"1"}}/>
         {!fileLifeImg?<img id="tecimage" src={e.image}  /> : <img id="tecimage" src={fileLifeImg}  />  }
         <span id="editimg-Tec"><i class="fa fa-pencil" aria-hidden="true" ></i></span>
         <span id="ErrB" className='error'></span>
        </div>
        <div className="md-form mb-4">
        <label id="sectionlable">Description</label> 
          <textarea type="text" id="textA"  defaultValue={e.text}/>
          <span id="ErrA" className='error'></span>
        </div> 
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddLife */}
<div className='tech-pop-fade' id="LifeAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"170px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD SECTION</h4>
        <button type="button" className="close" onClick={closeLifeAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecform" onSubmit={submitsectionLife} >
      <div className="modal-body mx-3">
        
        <div className="md-form mb-5">
          <label id="sectionlable">SlideImage</label>  
 
         <input type="file" onChange={handleFileChangeLife}/>
         
         <span id="AddErrB" className='error'></span>
        </div>
        <div className="md-form mb-5">
           
        <label id="sectionlable">Description</label> 
          <textarea type="text" id="text"/>
          <span id="AddErrA" className='error'></span>
        </div> 
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 




  {/* DeletePopup */}

  {EditSectionLife.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionLife(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}


<div className='tec-sectionMain' id="PopBTable" >
{
 sectionLife.length==0  ? (<div id="TecApiFail">" No Data Found "</div>):(
<div>
<div className='tectable'>

  <div class="tec-table_responsive">

<table>
  <thead>
    <tr>
      <th>SlideImage</th>
      <th>Description</th>
    
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {paginatedPostsB.map((e)=>{
    
  
    return<tr>
   
  
    <td><img src={e.image} alt="imgA" id="sectionImage"></img></td>
    <td>{e.text}</td>
    <td style={{whiteSpace:"nowrap"}}>
    {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionLife(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
      {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}
      {denied?<span className='error'>Denied</span>:null}
      </td>
    </tr>
 } )}
  </tbody>
</table>

</div>
</div>


<br></br>
{pageCountB==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pagesB.map((page)=>(
          <li className={
            page === currentPageB ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>paginationB(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
       
       {currentPageB >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPreviousB} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageB} Of {pageCountB} 
         
            </span>   &nbsp; &nbsp;
        {currentPageB<pageCountB?<li className="page-item">
              <a class="tecpage-link" onClick={onNextB} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}
</div>

)}



   

    </div>


    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}
  id="Loader"
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
 <div id="TecDenied">
   <span id="TecActionDeniedA"></span>

   </div>
    </div>

    

    </>
  )
}

export default TecLifeMain
